// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__327w4","header":"PatientBlock_header__39AmV","label":"PatientBlock_label__3NA9m","option":"PatientBlock_option__3deRg"};